import { createContext, useContext, useState, useMemo, useEffect } from 'react';
import PropTypes from 'prop-types';

const CourseContext = createContext(undefined);

export function CourseProvider({ children }) {
  const [selectedCourseId, setSelectedCourseId] = useState(null);

  const value = useMemo(() => ({
    selectedCourseId,
    setSelectedCourseId,
  }), [selectedCourseId]);

  useEffect(() => {
    if(localStorage.getItem('courseId')) {
      const courseId = localStorage.getItem('courseId');
      setSelectedCourseId(courseId);
    }
  }, []);

  return (
    <CourseContext.Provider value={value}>
      {children}
    </CourseContext.Provider>
  );
}

CourseProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export function useCourseContext() {
  const context = useContext(CourseContext);
  if (context === undefined) {
    throw new Error('useCourseContext must be used within a CourseProvider');
  }
  return context;
}
